import React from "react";
import DashboardLayout from "./DashboardLayout";

/**
 * AdminLayout - Dedicated layout wrapper for all Admin pages.
 * Pre-sets role="admin", userName="AutoBET Admin", userRole="Administrator".
 */
const AdminLayout = (props) => {
  return (
    <DashboardLayout
      role="admin"
      userName="AutoBET Admin"
      userRole="Administrator"
      {...props}
    />
  );
};

export default AdminLayout;
